import { z } from 'zod';

export const SignupAttributionSchema = z.object({
  utmSource: z.string().optional(),
  utmMedium: z.string().optional(),
  utmCampaign: z.string().optional(),
  utmTerm: z.string().optional(),
  utmContent: z.string().optional(),
  gclid: z.string().optional(),
  referrer: z.string().optional(),
  landingPath: z.string().optional(),
});

/**
 * First-touch signup attribution.
 *
 * Captured in the browser on a visitor's first landing (before the WorkOS
 * redirect) and persisted once per user, keyed by their WorkOS user id. Used
 * to power acquisition reporting (e.g. signups grouped by utm_source).
 */
export type SignupAttribution = z.infer<typeof SignupAttributionSchema>;

/** Request body for POST /attribution. */
export const RecordAttributionRequestSchema = SignupAttributionSchema;
export type RecordAttributionRequest = SignupAttribution;

/** A persisted attribution row as returned by the API. */
export const AttributionRecordSchema = SignupAttributionSchema.extend({
  userId: z.string(),
  createdAt: z.string(),
});
export type AttributionRecord = z.infer<typeof AttributionRecordSchema>;
